import React from 'react';
import { I18n } from '../../core/i18n/I18n';

var BooleanFilter = function BooleanFilter(_ref) {
  var value = _ref.value,
      name = _ref.name,
      title = _ref.title,
      _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
    htmlFor: "filter-input-".concat(name)
  }, /*#__PURE__*/React.createElement(I18n, null, title), ":"), /*#__PURE__*/React.createElement("select", {
    type: "text",
    name: "filter-input",
    id: "filter-input-".concat(name),
    value: value,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  }, /*#__PURE__*/React.createElement("option", null), /*#__PURE__*/React.createElement("option", {
    value: "true"
  }, "Yes"), /*#__PURE__*/React.createElement("option", {
    value: "false"
  }, "No")));
};

export default BooleanFilter;